import { TEST_SEGMENTS } from 'root-constants'

export const isTestGroup = (segment: string): boolean =>
  segment === TEST_SEGMENTS.VARIANT_B ||
  segment === TEST_SEGMENTS.VARIANT_C ||
  segment === TEST_SEGMENTS.VARIANT_D
